import { Icon } from '@components/icons';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import useModalContext from '@hooks/context/useModalContext';
import { prettifyStars } from '@utils/index';

const SetPreferredAccountModal = () => {
    const { modalData } = useModalContext();
    return (
        <div className={styles.wrapper}>
            <Icon name="check_outlined" width={60} height={60} />
            <Typography variant="h5">
                {modalData?.account_name} {prettifyStars(modalData?.account_number)}
            </Typography>
            <Typography variant="h5" weight="medium" className={styles.title}>
                will be set as your preferred payment method
            </Typography>
        </div>
    );
};

export default SetPreferredAccountModal;
